export default {
	title: "Dashboard",
	description: "Overview of the system's status.",
	lastUpdated: "Last updated: {{date}}",
	noDate: "No date",
	summaryCards: {
		feedAmount: "Feed Amount",
		seaTemp: "Avg. sea temp",
		airTemp: "Avg. air temp",
		oxygen: "Oxygen",
		salinity: "Salinity",
		wind: "Wind",
		readings: "Data readings",
	},
	detail: {
		types: {
			oxygen: "Oxygen",
			depth: "Depth",
			temperature: "Temperature",
			salinity: "Salinity",
		},
	},
	filter: {
		allSites: "All sites",
		allUnits: "All units",
		addSecondSite: "Add second site",
	},
	badges: {
		feeding: "Feeding",
		offline: "Offline",
		stopped: "Stopped",
		noData: "No data",
		active: "Active",
		unknown: "Unknown",
	},
	sortOptions: {
		name: "Name",
		biomass: "Biomass",
		activity: "Activity",
		feeding: "Feeding",
	},
	filterOptions: {
		all: "All ({{value}})",
		active: "Active ({{value}})",
		alarms: "Alarms ({{value}})",
	},
	feed: {
		intensity: "Intensity",
		feedAmount: "Feed Amount",
		recommendedFeedAmount: "Recommended Feed Amount",
	},
	buttons: {
		search: "Search",
		units: "Units",
		sites: "Sites",
		hideGraphics: "Hide Graphics",
		showGraphics: "Show Graphics",
		preferences: "Preferences",
		back: "Back to {{value}}",
		backToMultipleSites: "Back to sites",
		sortBy: "Sort by:",
		addNewView: "Add new view",
	},
	loading: {
		liveView: {
			sites: "Loading sites...",
			units: "Loading units...",
		},
	},
	errors: {
		liveView: {
			sites: {
				title: "Error loading sites {{value}}",
				description: "Something went wrong while loading the sites. Please try again later or with a different company.",
			},
			units: {
				title: "Error loading units {{value}}",
				description: "Something went wrong while loading the units. Please try again later or with a different site.",
			}
		}
	}
};
